var faq = {
	selectors: { },

	init: function () {
		var self = this;

		jQuery( document ).on('click', '.js-faq > h2', function (e) {
			e.preventDefault();

			jQuery( this ).next('div').slideToggle( 'fast' );
			jQuery( this ).parent( '.js-faq' ).toggleClass( 'active' );
        });
	},
};

export { faq };
